// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/button/index.css
// module id = 442
// module chunks = 32